import {useRef, useState} from "react";

export const useRequest = (initialFilters, productFilters, filterTypeMap, isMobile, headers ) => {
  const [submitted, setSubmitted] = useState(false);
  const [success, setSuccess] = useState(null);
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState(null);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const activeRequests = useRef(0);
  
  function loading() {
    document.body.style.cursor = 'wait';
    if(document.getElementById('spinner-container') != null){
      document.getElementById('spinner-container').style.display ="flex";
    }
    setLoadingSpinner(true);
  }

  function stopLoading() {
    document.body.style.cursor = 'default';
    if(document.getElementById('spinner-container') != null){
      document.getElementById('spinner-container').style.display = "none";
    }
    setLoadingSpinner(false);
  }

  function resetAlerts() {
    setErrors({});
    setMessage(null);
  }

  function beforeSubmit() {
    activeRequests.current += 1;
    setSubmitted(true);
    setSuccess(null);
    resetAlerts();
    loading();
  }

  function afterSubmit() {
    activeRequests.current = Math.max(activeRequests.current - 1, 0);

    if (activeRequests.current === 0) {
      setSubmitted(false);
      stopLoading();
    }
  }

  function showSuccess(message) {
    afterSubmit();
    setSuccess(true);
    setMessage(message);
  }

  function showError(message, errors = {}) {
    afterSubmit();
    setSuccess(false);
    setMessage(message);
    setErrors(errors);
  }

  function dealWithError(response, codeMsgError = "Error", callback = null) {
    if ([400, 401, 404, 409, 422].includes(response.status)) {
        response.json().then((data) => {
            if (Array.isArray(data)) {
                showError(data.join(", "));
            } else if ('detail' in data) {
                showError(data['detail']);
            } else if ('message' in data && 'error' in data) {
                showError(data['message'], data['error']);
            } else if ('error' in data) {
                showError(data['error']);
            } else {
                showError(codeMsgError, data);
            }
            if (callback) callback();
        });
    } else {
        showError(codeMsgError);
        if (callback) callback();      
    }
  }

  return {
    submitted, setSubmitted,
    success, setSuccess,
    errors, setErrors,
    message, setMessage,
    loadingSpinner, setLoadingSpinner,

    beforeSubmit, afterSubmit,
    showSuccess, showError,
    dealWithError
  };
}

export default useRequest;
